import React, { MouseEvent, CSSProperties, ReactNode } from "react";

export interface ButtonProps {
  type?: "button" | "submit" | "reset";
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void;
  className?: string;
  icon?: string | ReactNode;
  iconClass?: string;
  text?: string;
  badge?: { variant: string; text: string };
  arrow?: string;
  children?: ReactNode;
  style?: CSSProperties;
  loading?: boolean;
  disabled?: boolean;
}

export function Button({
  type,
  onClick,
  className,
  icon,
  iconClass,
  text,
  badge,
  arrow,
  children,
  style,
  loading,
  disabled = false,
}: ButtonProps) {
  return (
    <button disabled={loading || disabled} type={type || "button"} onClick={onClick} className={className} style={style}>
      {icon || iconClass ? <i className={iconClass || "material-icons"}>{icon}</i> : <></>}
      {text && <span>{text}</span>}
      {badge && <sup className={badge.variant}>{badge.text}</sup>}
      {arrow && <small className="material-icons">{arrow}</small>}
      {loading ? "loading..." : children}
    </button>
  );
}
